import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './pages/auth/login/login.component';
import { ResetPasswordComponent } from './pages/auth/reset-password/reset-password.component';

import { OverlayModule } from '@angular/cdk/overlay';
import { PortalModule } from '@angular/cdk/portal';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CookieService } from 'ngx-cookie-service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { AddPartnerModalComponent } from './components/add-partner-modal/add-partner-modal.component';
import { DeleteConfirmModalComponent } from './components/delete-confirm-modal/delete-confirm-modal.component';
import { DisabledUserComponent } from './components/disabled-user/disabled-user.component';
import { HeaderComponent } from './components/header/header.component';
import { PrivateLayoutComponent } from './components/layout/private-layout.component';
import { MessageErrorComponent } from './components/message-error/message-error.component';
import { NavListComponent } from './components/nav-list/nav-list.component';
import { MessagesComponent } from './components/notification/messages.component';
import { NotifierComponent } from './components/notifier/notifier.component';
import { SidenavHeaderComponent } from './components/sidenav-header/sidenav-header.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SharedModule } from './modules/_shared.module';
import { AuthComponent } from './pages/auth/auth/auth.component';
import { ChangePasswordComponent } from './pages/auth/login/change-password/change-password.component';
import { ForgetPasswordComponent } from './pages/auth/login/forget-password/forget-password.component';
import { SignupComponent } from './pages/auth/signup/signup.component';
import { ExternalProposalComponent } from './pages/proposal/external-proposal/external-proposal.component';
import { NewProposalConfirmModalComponent } from './pages/quotation/components/new-proposal-confirm-modal/new-proposal-confirm-modal.component';

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    SignupComponent,
    LoginComponent,
    ForgetPasswordComponent,
    ChangePasswordComponent,
    NavListComponent,
    ToolbarComponent,
    ResetPasswordComponent,
    ExternalProposalComponent,
    DisabledUserComponent,
    AddPartnerModalComponent,
    DeleteConfirmModalComponent,
    NewProposalConfirmModalComponent,
    MessageErrorComponent,
    NotifierComponent,
    SidenavComponent,
    SidenavHeaderComponent,
    HeaderComponent,
    PrivateLayoutComponent,
    MessagesComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    NgxSkeletonLoaderModule,
    OverlayModule,
    PortalModule,
  ],
  providers: [CookieService],
  bootstrap: [AppComponent],
})
export class AppModule {}
